webpackJsonp([70144966829960],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	})), 'AccountCircle');
	
	exports.default = _default;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(22));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	}), _react.default.createElement("path", {
	  fill: "none",
	  d: "M0 0h24v24H0z"
	})), 'Email');
	
	exports.default = _default;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GoogleMap = function (_React$Component) {
	  _inherits(GoogleMap, _React$Component);
	
	  function GoogleMap() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GoogleMap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.styles = {
	      map: _extends({}, _this.props.style, {
	        border: 0
	      })
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GoogleMap.prototype.render = function render() {
	    return _react2.default.createElement('iframe', {
	      src: this.props.url,
	      width: this.props.width || '100%',
	      height: this.props.height || 480,
	      className: this.styles.map,
	      frameBorder: 0,
	      allowFullScreen: true
	    });
	  };
	
	  return GoogleMap;
	}(_react2.default.Component);
	
	exports.default = GoogleMap;
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Typography = __webpack_require__(18);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Grid = __webpack_require__(37);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Divider = __webpack_require__(36);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Email = __webpack_require__(107);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _AccountCircle = __webpack_require__(294);
	
	var _AccountCircle2 = _interopRequireDefault(_AccountCircle);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _googleMap = __webpack_require__(109);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _contactModule = __webpack_require__(429);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.mapURL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.051234542316!2d151.18430796412534!3d-33.88833430672074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6a3aa3abbb927465!2sSusan%20Wakil%20Health%20Building%2C%20The%20University%20of%20Sydney!5e0!3m2!1sen!2sau!4v1620818640519!5m2!1sen!2sau', _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactPage.prototype.render = function render() {
	    var persons = this.props.data.contentfulSettings.personsOrder;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_googleMap2.default, { url: this.mapURL }),
	      _react2.default.createElement(
	        _container2.default,
	        {
	          size: 'large',
	          padding: '2rem'
	        },
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'h4',
	            gutterBottom: true
	          },
	          'Contact Us'
	        ),
	        _react2.default.createElement(_Divider2.default, { className: _contactModule2.default.divider }),
	        _react2.default.createElement(
	          _Grid2.default,
	          {
	            container: true,
	            spacing: 32,
	            className: _contactModule2.default.grid
	          },
	          persons.map(function (person, index) {
	            return _react2.default.createElement(
	              _Grid2.default,
	              {
	                item: true,
	                xs: 12,
	                sm: 6,
	                md: 4,
	                lg: 4,
	                key: index,
	                className: _contactModule2.default.item
	              },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                className: _contactModule2.default.image,
	                alt: person.name,
	                sizes: person.image.sizes
	              }),
	              person.slug ? _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: person.slug },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'h5', gutterBottom: true },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _contactModule2.default.link },
	                    person.name
	                  )
	                )
	              ) : _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'h5', gutterBottom: true },
	                person.name
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'h6', className: _contactModule2.default.paragraph, gutterBottom: true },
	                person.title
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'body1', className: _contactModule2.default.paragraph, gutterBottom: true },
	                _react2.default.createElement(
	                  'a',
	                  { className: _contactModule2.default.link, href: 'mailto:' + person.email },
	                  person.email
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"divider":"src-pages----contact-module---divider---CU_GG","paragraph":"src-pages----contact-module---paragraph---Wy51y","icon":"src-pages----contact-module---icon---Nv6u0","link":"src-pages----contact-module---link---w7c1G","item":"src-pages----contact-module---item---25FKe","image":"src-pages----contact-module---image---2IKYU"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-0809073432109d90f280.js